<template>
  <div class="_2zoVUbLx">
    <video src="/static/image/bg_batch-0ac1.mp4" class="_2FBwK8pA" autoplay="" preload="preload" loop=""></video>
    <div class="_2qyICCAn">
      <div class="DZfPXDqq">
        <a><img src="/static/image/w_logo1-a238.png" /></a>
      </div>
      <div class="_1xYhiAzf">
        <h3 class="_1xOfyRAi">用户注册</h3>
        <ul class="_9s4xncLL" id="yanzhangma">
          <li class="FzjZ-TwQ">
            <input type="text" name="userName" class="" placeholder="请输入注册账号" autocomplete="off" value="" />
            <i class="_3pvR4aic _3-xMSbk3"></i>
          </li>
          <li class="FzjZ-TwQ">
            <input type="password" name="passWord" class="" placeholder="请输入密码" autocomplete="new-password" value="" />
            <i class="_3pvR4aic _21QZXWVH"></i>
            <span class="u3IESPNo eyes" style="display: none"></span>
          </li>
          <li class="FzjZ-TwQ">
            <input type="password" name="confirmPass" class="" placeholder="请重复输入您的密码" value="" />
            <i class="_3pvR4aic _21QZXWVH"></i><span class="u3IESPNo eyes" style="display: none"></span>
          </li>
          <li class="FzjZ-TwQ">
            <input type="text" name="realname" class="" placeholder="请输入您真实姓名" value="" />
            <i class="_3pvR4aic _3-xMSbk3"></i><span class="u3IESPNo eyes" style="display: none"></span>
          </li>
          <li class="FzjZ-TwQ">
            <input type="password" name="paypassword" class="" placeholder="请输入您支付的密码" value="" />
            <i class="_3pvR4aic _21QZXWVH"></i><span class="u3IESPNo eyes" style="display: none"></span>
          </li>
          <li class="FzjZ-TwQ x2AzF1GR">
            <input type="text" name="validCode" class="" v-model="code" placeholder="验证码" autocomplete="off" data-analytics="button" data-label="注册-验证码" value="" />
            <i class="_3pvR4aic _1tbGk_Vo"></i>
            <div class="_3zcM8MXv">
              <img :src="`/static/image/${imgLis[index]}.png`" class="_1_iUfFmJ" />
              <img
                @click="changIndex"
                data-analytics="button"
                data-label="注册-获取验证码"
                src="data:image/png;base64,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"
                class="_112M2iQB"
              />
            </div>
          </li>

          <li>
            <div class="_19rglWPh">
              <label class="_1XkWFucM ant-checkbox-wrapper ant-checkbox-wrapper-checked"
                ><span class="ant-checkbox ant-checkbox-checked">
                  <input type="checkbox" class="ant-checkbox-input" value="" checked="" />
                  <span class="ant-checkbox-inner"></span></span
              ></label>
              <i>我已阅读并同意相关的<a>条款</a>和<a>隐私政策</a>。</i>
            </div>
          </li>
          <li>
            <div class="_349CzCYy xJQe3jRu Ntuq7wDg" @click="login"><span>注册</span></div>
          </li>
          <li style="margin-top: 0px; position: relative">
            <div class="_1ZEbIiBK"><span>已经有帐号? </span><a @click="goNav('/login')">请登录</a></div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'register',
  data() {
    return {
      index: 0,
      imgLis: ['7GQT', 'LFW3', 'NU2T', 'UAE3'],
      code: null,
    };
  },
  components: {},
  created() {
    let that = this;
    that.changIndex();
  },
  mounted() {
    $("input[name='userName']").bind('input propertychange', function () {
      var v = $(this).val();
      if (v == '') {
        $(this).next('._3pvR4aic').removeClass('_1uAyCaV3');
      } else {
        $(this).next('._3pvR4aic').addClass('_1uAyCaV3');
      }
    });
    $("input[name='realname']").bind('input propertychange', function () {
      var v = $(this).val();
      if (v == '') {
        $(this).next('._3pvR4aic').removeClass('_1uAyCaV3');
      } else {
        $(this).next('._3pvR4aic').addClass('_1uAyCaV3');
      }
    });

    $("input[name='passWord']").bind('input propertychange', function () {
      var v = $(this).val();
      if (v == '') {
        $(this).next('._3pvR4aic').removeClass('_1uAyCaV3');
        $(this).nextAll('.eyes').css('display', 'none');
      } else {
        $(this).next('._3pvR4aic').addClass('_1uAyCaV3');
        $(this).nextAll('.eyes').css('display', 'block');
      }
    });
    $("input[name='confirmPass']").bind('input propertychange', function () {
      var v = $(this).val();
      if (v == '') {
        $(this).next('._3pvR4aic').removeClass('_1uAyCaV3');
        $(this).nextAll('.eyes').css('display', 'none');
      } else {
        $(this).next('._3pvR4aic').addClass('_1uAyCaV3');
        $(this).nextAll('.eyes').css('display', 'block');
      }
    });
    $("input[name='paypassword']").bind('input propertychange', function () {
      var v = $(this).val();
      if (v == '') {
        $(this).next('._3pvR4aic').removeClass('_1uAyCaV3');
        $(this).nextAll('.eyes').css('display', 'none');
      } else {
        $(this).next('._3pvR4aic').addClass('_1uAyCaV3');
        $(this).nextAll('.eyes').css('display', 'block');
      }
    });
    $("input[name='validCode']").bind('input propertychange', function () {
      var v = $(this).val();
      if (v == '') {
        $(this).next('._3pvR4aic').removeClass('_1uAyCaV3');
      } else {
        $(this).next('._3pvR4aic').addClass('_1uAyCaV3');
      }
    });
    var i = true; 
    $('.eyes').click(function () {
      if (i) {
        $(this).addClass('_1xpiRCSg');
        $(this).prevAll('input').attr('type', 'text');
        i = false;
      } else {
        $(this).removeClass('_1xpiRCSg');
        $(this).prevAll('input').attr('type', 'password');
        i = true;
      }
    });
  },
  methods: {
    changIndex() {
      this.index = parseInt(3 * Math.random());
    },
    goNav(url) {
      this.$router.push({ path: url });
    },
    login() {
      let that = this;

      let info = {
        name: $("input[name='userName']").val(),
        password: $("input[name='passWord']").val(),
        confirmPass: $("input[name='confirmPass']").val(),
        realname: $("input[name='realname']").val(),
        paypassword: $("input[name='paypassword']").val(),
      };
      console.log(info);
      if (info.name == '' || info.name.length < 6) {
        that.showTost(' 用户名长度6~16位，以字母或数字组合！');
        return;
      }
      if (info.password == '' || info.password.length < 6) {
        that.showTost('请输入正确的密码长度，最少6位！');
        return;
      }
      if (info.confirmPass == '' || info.confirmPass != info.password) {
        that.showTost('两次密码不一致！');
        return;
      }
      if (info.realname == '' || info.realname.length < 2) {
        that.showTost('请输入您的真实姓名!');
        return;
      }

      if (info.paypassword == '' || info.paypassword.length < 6) {
        that.showTost('请输入正确的支付密码长度，最少6位！');
        return;
      }
      if (that.code.toUpperCase() != that.imgLis[that.index]) {
        that.showTost('验证码错误！');
        that.code = null;
        that.changIndex();
        return;
      }
      that.$apiFun.register(info).then(res => {
         that.showTost(res.message);
        if (res.code == 200) {
          sessionStorage.setItem('token', res.data.api_token);
          that.getUserInfo();
        }
      });
    },
    showTost(title) {
      $('body').append(`
            <div class='ant-message' style='top: 400px;'><span><div class='ant-message-notice'><div class='ant-message-notice-content'>
            <div class='ant-message-custom-content ant-message-info'><span role='img' aria-label='info-circle' class='anticon anticon-info-circle'>
            <svg viewBox='64 64 896 896' focusable='false' data-icon='info-circle' width='1em' height='1em' fill='currentColor' aria-hidden='true'>
            <path d='M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z'></path></svg></span><span>
            ${title}
            </span></div></div></div></span>
            </div>`);
      setTimeout('$(".ant-message").detach()', 1500);
    },
    getUserInfo() {
      let that = this;
      that.$apiFun.post('/api/user', {}).then(res => {
  
        if (res.code === 200) {
          localStorage.setItem('userInfo', JSON.stringify(res.data));
          that.$store.commit('changUserInfo');
          that.goNav('/');
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.fangda {
  animation: _308UEapr 0.5s ease-out;
}
.hover {
  display: none;
}
._3gi7jqcw:hover ._2JoosS9F {
  display: none;
}
._3gi7jqcw:hover .hover {
  display: block;
}
._3gi7jqcw._12ZkQT2g ._2JoosS9F {
  display: none;
}
._3gi7jqcw._12ZkQT2g .hover {
  display: block;
}
.ant-tabs-nav .ant-tabs-tab {
  height: 46px;
}
</style>



// WEBPACK FOOTER //
// src/components/Register.vue